module.exports = __webpack_public_path__ + "static/img/icon_dpj.d7ec9d4f.svg";